/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import * as _ from "underscore";
import Theme from "../utils/Theme";
import { WhiteSpace } from "antd-mobile";
import StarRatingComponent from "react-star-rating-component";
import CountdownLabel from "./CountdownLabel";
import FavouriteButton from "./FavouriteButton";
import AddToCartButton from "./AddToCartButton";

const StyledContainer = styled.div`
  cursor: pointer;
  display: block;
  width: ${props => (props.horizontal ? "100%" : "49%")};
  margin-bottom: 7px;
`;

const StyledVerticalContainer = styled.div`
  border: 1px solid lightgray;
  height: auto;
  background: white;
  box-shadow: 0 4px 6px -5px grey;
`;

const StyledContentContainer = styled.div`
  padding: 0.3em 1.1em;
  display: flex;
  flex-direction: column;
`;

const StyledSpaceBetweenContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const StyledRatingContainer = styled.div`
  font-size: 0.75em;
`;

const StyledTitle = styled.span`
  text-align: start;
  width: 100%;
  font-weight: bold;
  color: black;
  line-height: 1.6;
  font-size: 0.9em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const StyledDescription = styled.span`
  text-align: start;
  width: 100%;
  color: grey;
  line-height: 1.6;
  font-size: 0.85em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const StyledPrice = styled.span`
  font-weight: ${props => (props.horizontal ? "normal" : "bold")};
  color: black;
  font-size: ${props => (props.horizontal ? "1.15em" : "0.95em")};
`;

const StyledHorizontalContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: auto;
`;

const StyledHorizontalLeftContainer = styled.div`
  display: flex;
  flex: 3.3;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0.3em 0.8em 0.9em 0.8em;
  border: 1px solid lightgray;
  border-right: 0.5px solid lightgray;
  border-radius: 8px;
  background: white;
  box-shadow: 0 4px 6px -5px grey;
`;

const StyledHorizontalRightContainer = styled.div`
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  flex: 6.7;
  flex-direction: column;
  border: 1px solid lightgray;
  border-left: 0.5px solid lightgray;
  border-radius: 8px;
  background: white;
  padding: 0.5em 0.8em 0.5em 0.8em;
  box-shadow: 0 4px 6px -5px grey;
`;

const StyledMultiLineDescription = styled.span`
  color: grey;
  text-align: start;
  display: block;
  display: -webkit-box;
  width: 100%;
  max-width: 100%;
  height: 2.5em;
  margin: 0 auto;
  font-size: 0.85em;
  line-height: 1.4;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const StyledPriceContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

class ProductItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fade: false
    };
  }

  // updateDimensions = () => {
  //   if (this.itemImage && this.itemImage.width) {
  //     this.itemImage.height = this.itemImage.width;
  //   }
  // };

  // UNSAFE_componentWillMount = () => {
  //   this.updateDimensions();
  // };
  // componentDidMount = () => {
  //   window.addEventListener("resize", this.updateDimensions);
  // };
  // componentWillUnmount = () => {
  //   window.removeEventListener("resize", this.updateDimensions);
  // };

  getPrice = () => {
    const { price } = this.props;

    return price ? price : "RM 0.00";
  };

  getVerticalView = () => {
    const {
      imageSrc,
      onFavourited,
      title,
      description,
      countdownLabel,
      review,
      isFavourited
    } = this.props;

    return (
      <StyledVerticalContainer>
        <StyledContentContainer>
          <StyledSpaceBetweenContainer>
            <CountdownLabel title={countdownLabel} />
            <FavouriteButton
              liked={isFavourited}
              onClicked={liked => onFavourited && onFavourited(liked)}
              style={{ marginRight: "-8px" }}
            />
          </StyledSpaceBetweenContainer>
          <WhiteSpace size={"sm"} />
          <img
            ref={ref => (this.itemImage = ref)}
            src={imageSrc}
            alt=""
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              width: "100%",
              minHeight: "4em"
            }}
            onLoad={() => {
              window.dispatchEvent(new Event("resize"));
              // this.itemImage.height = this.itemImage.width;
            }}
          />
          <WhiteSpace size={"sm"} />
          <StyledTitle>{title}</StyledTitle>
          <StyledDescription
            style={{
              visibility: _.isEmpty(description) ? "hidden" : "visible"
            }}
          >
            {_.isEmpty(description) ? "No Description..." : description}
          </StyledDescription>
          <WhiteSpace size={"sm"} />
          <StyledSpaceBetweenContainer>
            <StyledRatingContainer>
              <StarRatingComponent
                name={"productItemRating"}
                editing={false}
                starCount={5}
                value={review}
                starColor={Theme.PrimaryColor}
                emptyStarColor={"lightgrey"}
              />
            </StyledRatingContainer>
            <StyledPrice>{this.getPrice()}</StyledPrice>
          </StyledSpaceBetweenContainer>
        </StyledContentContainer>
      </StyledVerticalContainer>
    );
  };

  getHorizontalView = () => {
    const {
      horizontal,
      imageSrc,
      onItemAddToCart,
      onFavourited,
      title,
      description,
      countdownLabel,
      review,
      isFavourited,
      isAvailable
    } = this.props;

    return (
      <StyledHorizontalContainer>
        <StyledHorizontalLeftContainer>
          <CountdownLabel title={countdownLabel} />
          <img
            ref={ref => (this.itemImage = ref)}
            src={imageSrc}
            alt=""
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              width: "100%",
              minHeight: "4em",
              marginTop: "4px"
            }}
            onLoad={() => {
              window.dispatchEvent(new Event("resize"));
              // this.itemImage.height = this.itemImage.width;
            }}
          />
        </StyledHorizontalLeftContainer>
        <StyledHorizontalRightContainer>
          <StyledTitle>{title}</StyledTitle>
          <FavouriteButton
            liked={isFavourited}
            onClicked={liked => onFavourited && onFavourited(liked)}
            style={{
              position: "absolute",
              top: 4,
              right: 4
            }}
          />
          <WhiteSpace size={"xs"} />
          <StyledMultiLineDescription>{description}</StyledMultiLineDescription>
          <WhiteSpace size={"lg"} />
          <StyledSpaceBetweenContainer>
            <StyledPriceContentContainer>
              <StyledPrice horizontal={horizontal}>
                {this.getPrice()}
              </StyledPrice>
              <WhiteSpace size={"sm"} />
              <StyledRatingContainer>
                <StarRatingComponent
                  name={"productItemRating"}
                  editing={false}
                  starCount={5}
                  value={review}
                  starColor={Theme.PrimaryColor}
                  emptyStarColor={"lightgrey"}
                />
              </StyledRatingContainer>
            </StyledPriceContentContainer>
            {isAvailable ? (
              <AddToCartButton
                onClicked={() => onItemAddToCart && onItemAddToCart()}
              />
            ) : null}
          </StyledSpaceBetweenContainer>
        </StyledHorizontalRightContainer>
      </StyledHorizontalContainer>
    );
  };

  onItemClicked = () => {
    const { onItemClicked } = this.props;

    if (onItemClicked) {
      onItemClicked();
    }

    this.setState({ fade: true });
  };

  render() {
    const { fade } = this.state;
    const { horizontal } = this.props;

    return (
      <StyledContainer
        className={fade ? "fade" : ""}
        onAnimationEnd={() => this.setState({ fade: false })}
        horizontal={horizontal}
        onClick={() => this.onItemClicked()}
      >
        {horizontal ? this.getHorizontalView() : this.getVerticalView()}
      </StyledContainer>
    );
  }
}

ProductItem.propTypes = {
  horizontal: PropTypes.bool,
  onItemClicked: PropTypes.func,
  onFavourited: PropTypes.func,
  onItemAddToCart: PropTypes.func,
  imageSrc: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  countdownLabel: PropTypes.string,
  review: PropTypes.number,
  price: PropTypes.string,
  isFavourited: PropTypes.bool,
  isAvailable: PropTypes.bool
};

ProductItem.defaultProps = {
  imageSrc: "https://via.placeholder.com/300x300",
  horizontal: false,
  title: "",
  description: "",
  countdownLabel: "",
  review: 0,
  price: "",
  isFavourited: false
};

export default ProductItem;



// WEBPACK FOOTER //
// ./src/components/ProductItem.js